import { Button, Stack, Typography } from "@mui/material";
import Logo from "Assets/logo-graph.svg";
import LogoWhite from "Assets/logo-white.svg";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";

type Props = {
  color: "dark" | "light";
};

export const CreatedWith = ({ color }: Props) => {
  const textColor = color === "dark" ? "text.primary" : "white";

  return (
    <Stack alignItems="center">
      <Button
        variant="text"
        color="secondary"
        endIcon={<ArrowOutwardRoundedIcon />}
        onClick={() => {
          window.open("/", "_blank");
        }}
      >
        Sell your cookies on Flowlylink
      </Button>
    </Stack>
  );
};
